import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './auth/AuthProvider';
import { ErrorBoundary } from './ErrorBoundary';
import App from './App';
import { AdminApp } from './admin/AdminApp';

const isAdminRoute = window.location.pathname.startsWith('/admin');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        {isAdminRoute ? <AdminApp /> : <App />}
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
